<template>
    <div class="platform-icon" :style="{ '--platform-width': `${size}px`, '--platform-height': `${size}px` }">
        <template v-if="tippyDisabled">
            <component :is="currentPlatform.component" :color="currentPlatform.color" />
        </template>
        <template v-else>
            <component
                :is="currentPlatform.component"
                :color="currentPlatform.color"
                v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [600, 0], content: currentPlatform.content }"
            />
        </template>
    </div>
</template>

<script>
import TelegramIcon from "../../../../../views/Pages/Chatbot/pages/integrations/svg/TelegramIcon.vue";
import TrendyolIcon from "../../../../../views/Pages/Chatbot/pages/integrations/svg/TrendyolIcon.vue";
import WhatsappSvg from "../../svg/WhatsappSvg.vue";
import MessengerIcon from "../../../../../views/Pages/Chatbot/pages/integrations/svg/MessengerIcon.vue";
import BrowserSvg2 from "../../svg/Browser2Svg.vue";
import Instagram from "../../../../svg/stepper/Instagram.vue";
import WhatsappBusinessIcon from "../../../../../views/Pages/Chatbot/pages/integrations/svg/WhatsappBusinessIcon.vue";
import WhatsappV2 from "../../../../../views/Pages/Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV2.vue";
import LinkedinIcon from "../../../../../views/Pages/Chatbot/pages/integrations/svg/LinkedinIcon.vue";
import WhatsappV3Icon from "../../../../../views/Pages/Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV3.vue";

export default {
    name: "PlatformIcon",
    components: {
        WhatsappV3Icon,
        LinkedinIcon,
        Instagram,
        BrowserSvg2,
        MessengerIcon,
        WhatsappSvg,
        WhatsappBusinessIcon,
        WhatsappV2,
        TelegramIcon,
        TrendyolIcon
    },
    props: {
        platform: {
            type: String,
            default: null,
        },
        size: {
            type: Number,
            default: 18,
        },
        tippyDisabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            platformMappings: [
                {
                    component: "WhatsappSvg",
                    color: "green",
                    type: "whatsapp",
                    content: "Whatsapp"
                },
                {
                    component: "Instagram",
                    type: "instagram",
                    content: "Instagram"
                },
                {
                    component: "MessengerIcon",
                    type: "messenger",
                    content: "Messenger"
                },
                {
                    component: "TelegramIcon",
                    type: "telegram",
                    content: "Telegram"
                },
                {
                    component: "WhatsappBusinessIcon",
                    color: "#59c864",
                    type: "whatsapp-business-api",
                    content: "Whatsapp Business API"
                },
                {
                    component: "WhatsappBusinessIcon",
                    color: "#59c864",
                    type: "whatsapp-business-api-supsis",
                    content: "Whatsapp Business API V2"
                },
                {
                    component: "WhatsappV2",
                    color: "#59c864",
                    type: "whatsapp-v2",
                    content: "Web"
                },
                {
                    component: "WhatsappV3Icon",
                    color: "#59c864",
                    type: "whatsapp-unipile",
                    content: "Whatsapp V3"
                },
                {
                    component: "LinkedinIcon",
                    color: "#59c864",
                    type: "linkedin",
                    content: "Linkedin"
                },
                {
                    component: "TrendyolIcon",
                    type: "trendyol",
                    content: "Trendyol"
                },
                {
                    component: "WhatsappSvg",
                    color: "red",
                    type: "notWp",
                    content: "Kanal silinmiş ya da bağlantısı koparılmıştır."
                }
            ]
        };
    },
    computed: {
        currentPlatform() {
            const normalizedPlatform = this.platform ? this.platform.toLowerCase().trim() : null;
            const found = this.platformMappings.find(p => p.type === normalizedPlatform);
            
            return found || {
                component: "BrowserSvg2",
                type: "web",
                content: "Web"
            };
        }
    }
};
</script>
<style lang="scss" scoped>
.platform-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--platform-width);
    height: var(--platform-height);

    svg {
        width: var(--platform-width);
        height: var(--platform-height);
    }
}
</style>
